


<template>
  <v-dialog v-model="show" :fullscreen="true">
    <div style="height: 100%; background-color: black" id="preso1">
      <div class="reveal deck2">
        <div class="slides">
          <circle-of-life />

          <weather v-if="facility && facility.presentation_showweather" />

          <harvests v-model="topHarvests" />

          <high-thc-harvests v-model="highThc" />

          <lifecycle-reports v-model="lifecycleReports" />

          <high-terps v-model="highTerps" />

          <hardware-profile v-model="hardwareSpecs" />

          <stocks
            v-model="facility.presentation_stocks"
            v-if="facility && facility.presentation_stocks"
            ref="stocks"
          />

          <clock v-if="facility && facility.presentation_showclock" />
        </div>
      </div>
      <div
        @click="show = false"
        style="
          background: url(/img/AgrifyLogo.svg);
          background-size: contain;
          background-repeat: no-repeat;
          position: absolute;
          bottom: 10px;
          right: 70px;
          width: 70px;
          height: 70px;
        "
      />
    </div>

    <div
      style="
        position: absolute;
        top: 50px;
        right: 70px;
        width: 40px;
        height: 40px;
      "
    >
      <v-btn v-if="!musicPlaying" icon @click="onMusic"
        ><v-icon large color="white">volume_off</v-icon></v-btn
      >
      <v-btn v-else icon @click="onMusic"
        ><v-icon large color="white">volume_up</v-icon></v-btn
      >
    </div>

    <audio id="presentationAudio" src="/sounds/presentationmode.mp3" loop />
  </v-dialog>
</template>




<script>
import { mapGetters, mapActions } from "vuex";
import Trimaster from "@/plugins/servers/trimaster.js";
import Metrc from "@/plugins/servers/metrc.js";
import Reveal from "reveal.js";
import moment from "moment";

import Clock from "../Clock.vue";
import Weather from "../Weather.vue";
import Stocks from "../Stocks.vue";
import Harvests from "./Harvests.vue";
import HardwareProfile from "./HardwareProfile.vue";
import LifecycleReports from "./LifecycleReports.vue";
import HighThcHarvests from "./HighThcHarvests.vue";
import HighTerps from "./HighTerps.vue";
import CircleOfLife from "./CircleOfLife.vue";

export default {
  name: "",
  props: ["value"],
  components: {
    Clock,
    Weather,
    Stocks,
    Harvests,
    HardwareProfile,
    LifecycleReports,
    HighThcHarvests,
    HighTerps,
    CircleOfLife,
  },
  data() {
    return {
      facility: null,
      revealInstance: null,
      show: false,
      revealInstance: null,
      timer: null,
      initialized: false,
      topHarvests: [],
      hardwareSpecs: {},
      lifecycleReports: [],
      highThc: [],
      highTerps: [],
      musicPlaying: false,
    };
  },
  beforeMount() {},
  mounted() {},
  destroyed() {
    this.initialized = false;
    this.revealInstance = null;
  },
  computed: {
    ...mapGetters(["getUser"]),
  },
  watch: {
    show(newVal, oldVal) {
      if (!newVal) {
        this.musicPlaying = false;
        this.$emit("input", false);
      } else {
        if (this.initialized) {
          this.doReveal();
        }
      }
    },
    value: {
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.refresh();
          this.show = true;
          this.timer = setInterval(this.refresh, 300000);
          let me = this;
          setTimeout(function () {
            me.doReveal();
            me.initialized = true;
          }, 500);
        } else {
          if (this.timer) {
            clearInterval(this.timer);
          }
          document.getElementById("presentationAudio").pause();
        }
      },
      immediate: true,
    },
  },
  methods: {
    doReveal() {
      const config = {
        controls: false,
        help: false,
        autoPlayMedia: true,
        loop: true,
        autoSlide: 8000,
        overview: false,
      };

      // the problem is that we're getting the first item created
      if (!this.revealInstance) {
        this.revealInstance = new Reveal(document.querySelector(".deck2"));
        this.revealInstance.initialize(config);
      }

      // this.revealInstance.sync();
      this.revealInstance.toggleOverview(false);
      this.revealInstance.toggleAutoSlide(true);
      // this.revealInstance.slide(0);
    },
    getFacility() {
      let me = this;
      Trimaster.get(
        "facilities/" + me.getUser.facility_id,
        me.getUser.apitoken
      ).then(function ([res, err]) {
        me.facility = res;
      });
    },
    onMusic() {
      if (!this.musicPlaying) {
        this.musicPlaying = true;
        this.playAudio();
      } else {
        let domEl = document.getElementById("presentationAudio");
        domEl.pause();
        this.musicPlaying = false;
      }
    },
    playAudio() {
      let me = this;
      let domEl = document.getElementById("presentationAudio");
      if (domEl) {
        domEl.play();
      }
    },
    refresh() {
      let me = this;

      this.getFacility();

      Trimaster.get("goodnews/getNews", this.getUser.apitoken, {
        days: 100,
        hardware_product_id: 33,
      }).then(function ([res, err]) {
        if (res) {
          // top harvests
          me.topHarvests = res.harvestWeights;

          // reformat hardwareSpecs
          let hardwareSpecs = {};
          for (let i = 0; i < res.hardwareSpecs.length; i++) {
            let rec = res.hardwareSpecs[i];
            if (
              rec.label != "Dimmable" &&
              (rec.stringvalue || rec.numbervalue)
            ) {
              let key =
                rec.hardware_product_label +
                "-" +
                rec.hardware_property_category_label;
              if (rec.datatype == "Image" && rec.stringvalue) {
                key += " - " + rec.label;
              }
              if (!hardwareSpecs[key]) {
                hardwareSpecs[key] = [];
              }
              if (rec.stringvalue || rec.numbervalue) {
                hardwareSpecs[key].push(rec);
              }
            }
          }
          me.hardwareSpecs = hardwareSpecs;

          // images
          let images = [];
          for (let i = 0; i < res.lifecycleReports.length; i++) {
            let rec = res.lifecycleReports[i];

            if (rec.fileUploadUrl1) {
              images.push({
                date: moment(rec.begintime).format("MM/DD/YYYY"),
                url: rec.fileUploadUrl1,
                platformGroupName: rec.platformGroupName,
              });
            }
            if (rec.fileUploadUrl2) {
              images.push({
                date: moment(rec.begintime).format("MM/DD/YYYY"),
                url: rec.fileUploadUrl2,
                platformGroupName: rec.platformGroupName,
              });
            }
            if (rec.fileUploadUrl3) {
              images.push({
                date: moment(rec.begintime).format("MM/DD/YYYY"),
                url: rec.fileUploadUrl3,
                platformGroupName: rec.platformGroupName,
              });
            }
            if (rec.fileUploadUrl4) {
              images.push({
                date: moment(rec.begintime).format("MM/DD/YYYY"),
                url: rec.fileUploadUrl4,
                platformGroupName: rec.platformGroupName,
              });
            }
          }

          // select 5 random, non-repeating images
          let arr = [];
          let numImages = 10;
          if (images.length < numImages) {
            numImages = images.length - 1;
          }
          while (arr.length < numImages || arr.length == images.length) {
            var r = Math.floor(Math.random() * images.length);
            if (arr.indexOf(r) === -1) arr.push(r);
          }

          me.lifecycleReports = [];
          for (let i = 0; i < arr.length; i++) {
            me.lifecycleReports.push(images[arr[i]]);
          }
        }
      });

      Metrc.get("goodnews/getNews", {
        days: 100,
      }).then(function ([res, err]) {
        // highThc -- break into groups of 5
        let highThcResults = [];
        let counter = 0;

        for (let i = 0; i < res.highThc.length; i++) {
          if (counter == 0) {
            highThcResults.push([]);
          }
          highThcResults[highThcResults.length - 1].push(res.highThc[i]);
          counter++;
          if (counter == 4) {
            counter = 0;
          }
        }
        me.highThc = highThcResults;

        // high terp breakdown

        let terpResults = {};
        for (let i = 0; i < res.terpDetail.length; i++) {
          let rec = res.terpDetail[i];
          if (!terpResults[rec.SourcePackageLabel]) {
            terpResults[rec.SourcePackageLabel] = {
              tests: {},
              ProductCategoryName: rec.ProductCategoryName,
              ProductName: rec.ProductName,
              TestPerformedDate: rec.TestPerformedDate,
            };
          }
          terpResults[rec.SourcePackageLabel].tests[
            rec.translatedTestTypeName
          ] = rec.TestResultLevel;
        }

        // break into 4 at a time
        counter = 0;
        let terpRes = [];
        for (let key in terpResults) {
          if (counter == 0) {
            terpRes.push([]);
          }
          terpRes[terpRes.length - 1].push(terpResults[key]);
          counter++;
          if (counter == 4) {
            counter = 0;
          }
        }

        me.highTerps = terpRes;
      });

      if (this.$refs.stocks) {
        this.$refs.stocks.refresh();
      }
    },
  },
};
</script>

<style lang="scss">
</style>
